import { render } from "./documentTemplatesManagementForm.vue?vue&type=template&id=05010d85&scoped=true"
import script from "./documentTemplatesManagementForm.vue?vue&type=script&lang=js"
export * from "./documentTemplatesManagementForm.vue?vue&type=script&lang=js"

import "./documentTemplatesManagementForm.vue?vue&type=style&index=0&id=05010d85&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05010d85"]])

export default __exports__